import { useEffect, useState, useCallback } from "react";
import customerService from "@/services/customerService";

export default function useCustomerSegments(branchId) {
  const [segments, setSegments] = useState({
    atRisk: 0,
    vips: 0,
    birthdayThisWeek: 0,
    anniversaryThisWeek: 0,
    pointsExpiring: 0,
    newCustomers: 0,
    regulars: 0,
  });

  const [loading, setLoading] = useState(false);

  const fetchSegments = useCallback(async () => {
    setLoading(true);
    try {
      const res = await customerService.getCustomerSegmentCounts({
        branchId: branchId || undefined,
      });
      if (res?.data) {
        setSegments(res.data);
      }
    } finally {
      setLoading(false);
    }
  }, [branchId]);

  useEffect(() => {
    fetchSegments();
  }, [fetchSegments]);

  return {
    segments,
    loading,
    refetch: fetchSegments,
  };
}
